import { Helmet } from 'react-helmet-async';

import OfflineView from 'src/sections/system/error/offline-view';
import SystemPageDebugAccess from 'src/sections/system/debug/SystemPageDebugAccess';

// ----------------------------------------------------------------------

export default function OfflinePage() {
  return (
    <>
      <Helmet>
        <title>No Internet Connection - PointCraft</title>
      </Helmet>

      <SystemPageDebugAccess />
      <OfflineView />
    </>
  );
}
